type NewsItem = {
  text: string;
  link: string;
};

type UpdateStripProps = {
  newsItems?: NewsItem[];
};

const defaultNews: NewsItem[] = [];

export function UpdateStrip({ newsItems = defaultNews }: UpdateStripProps) {
  // Return null if no news items
  if (!newsItems || newsItems.length === 0) {
    return null;
  }

  // Duplicate items for seamless loop
  const duplicatedItems = [...newsItems, ...newsItems];

  return (
    <div className="relative w-full overflow-hidden border-b border-[rgba(77,183,247,0.3)]
                    bg-gradient-to-r from-[rgba(77,183,247,1)] via-[rgba(52,211,153,0.95)] to-[rgba(77,183,247,1)]
                    shadow-[0_0_30px_rgba(77,183,247,0.5),0_0_60px_rgba(52,211,153,0.3)]">
      {/* Neon glow effect */}
      <div className="pointer-events-none absolute inset-0 opacity-40 blur-3xl
                      bg-gradient-to-r from-[rgba(77,183,247,0.8)] via-[rgba(52,211,153,0.7)] to-[rgba(77,183,247,0.8)]" />
      
      <div className="news-strip-wrapper">
        <div className="news-strip whitespace-nowrap py-2.5">
          {duplicatedItems.map((item, index) => (
            <span key={`${item.link}-${index}`} className="inline-flex items-center">
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 text-sm font-medium text-white hover:text-white/90 transition-colors
                           font-mono uppercase tracking-[0.1em] whitespace-nowrap"
              >
                <span className="inline-flex items-center gap-2">
                  <span className="text-[10px] text-white/80 font-semibold">LATEST:</span>
                  <span className="text-white font-semibold drop-shadow-[0_0_10px_rgba(255,255,255,0.5),0_0_20px_rgba(77,183,247,0.4)]">{item.text}</span>
                </span>
              </a>
              {/* Separator between items */}
              {index < duplicatedItems.length - 1 && (
                <span className="inline-block text-white/40 text-lg px-4 whitespace-nowrap">•</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

